import { IonButton, IonCheckbox, IonCol, IonContent, IonRadio, IonRadioGroup, IonText, IonGrid, IonInput, IonItem, IonLabel, IonPage, IonRow } from "@ionic/react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CreditPay from "../../components/CreditPay";
import CreditPayDirect from "../../components/CreditPayDirect";
import Footer from "../../components/Footer";
import UserTerms from "../../components/UserTerms";
import { User } from "../../models/data";
import { translation } from "../../models/translation";


interface CreditProps {
    user: User
}
const Credit: React.FC<CreditProps> = (props) => {

    const siteText = translation();


    const contributionList = [
        {
            name: 'none',
            value: 0.00,
            label: '0%'
        },
        {
            name: 'basic',
            value: 0.03,
            label: '3%'
        },
        {
            name: 'middle',
            value: 0.05,
            label: '5%'
        },
        {
            name: 'basic',
            value: 0.07,
            label: '7%'
        }
    ]

    const [tip,setTip] = useState<number>(() => {
        return contributionList[2].value
    });


    const [amount, setAmount] = useState<any>();

    // 0 online payment // 1 direct transfer
    const [paymentMode, setPaymentMode] = useState(0);
    const [onlinePaymentStep, setOnlinePaymentStep] = useState<number>(0);
    const [terms, agreeTerms] = useState(false);

    const [userTerms, showUserTerms] = useState<boolean>(false);


    const [contribution, setContribution] = useState<any>(1);

    const [totalAmount, setTotalAmount] = useState<any>(() => {
        return (amount) + (amount * tip * contribution)
    });

    const toggleContribution = () => {
        let current = contribution;
        setContribution(current !== 0 ? 0 : 1);
    }

    /*Close open user terms  */
    const toggleUserTerms = () => {
        let current = userTerms;
        showUserTerms(!current);
    }

    const updateTotalAmount = () => {
        setTotalAmount((+amount + (amount * tip * contribution)).toFixed(2))
    }

    const contributionToCash = (value: any) => {
        let commission = amount * value
        commission = Math.round(commission * 100) / 100
        if (isNaN(commission)) {
            return 0
        }
        return commission
    }

    const amountSummary = (amount: any, commission: any) => {
        let summary = +amount + (amount * commission)
        summary = Math.round(summary * 100) / 100
        return summary
    }


    useEffect(() => {
        let mounted = true;
        if (mounted) { resetP() }
    }, [])

    useEffect(() => {
        updateTotalAmount()
    }, [amount, contribution, tip])

    const resetP = () => {
        setOnlinePaymentStep(0)
    }

    if (paymentMode === 1) {
        return <CreditPayDirect changePaymentMethod={setPaymentMode} />
    } else if (onlinePaymentStep === 1) {
        return <IonPage>
            <IonContent>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <CreditPay resetCredit={resetP} type="credit" amount={totalAmount} donateData={{tip:+tip*amount}} user={props.user}></CreditPay>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                <Footer></Footer>
            </IonContent>
        </IonPage>
    } else {
        return (
            <IonPage className="viewContainer">
                <IonContent className="ion-padding">
                {!userTerms ? <IonGrid className="mainContent">
                        <IonRow><IonCol>
                            <h1>{siteText.creditAccountStartTitle}</h1>
                        </IonCol></IonRow>
                        <IonRow>
                            <IonCol size="8">
                                <form>
                                    <IonLabel>{siteText.creditAccountStartAmountLabel}</IonLabel>
                                    <IonInput autofocus className="ion-margin-top" value={amount} type="number" min={0} placeholder={siteText.creditAccountStartAmountPlh} onIonChange={e => setAmount(e.detail.value)}></IonInput>

                                    <h4>{siteText.donateDirectlyPaySubtotalText} {amount ? totalAmount : 0} CHF</h4>

                                    <p>{siteText.donateDirectlyPayTipRequest}</p>
                                    <IonRadioGroup style={{ display: 'flex' }} className="ion-margin-bottom" value={tip} onIonChange={(e: any) => setTip(e.detail.value)}>
                                        {contributionList.map((m, key) => <IonItem className="ion-margin-end" lines="none" key={key}><IonLabel className="ion-margin-end">{contributionToCash(m.value)} CHF</IonLabel> <IonRadio value={m.value}></IonRadio></IonItem>)}
                                    </IonRadioGroup>


                                    <IonItem lines="none" className="borderedInput">
                                        <IonLabel className="ion-text-wrap"> <Link to="terms_of_use" onClick={e => { e.preventDefault(); toggleUserTerms(); }}>{siteText.donateDirectlypayConfirm}</Link> </IonLabel>
                                        <IonCheckbox slot="start" checked={terms} onIonChange={() => { agreeTerms(!terms) }} />
                                    </IonItem>

                                    <div className="sw_sp_sm">
                                        <IonButton disabled={!terms || !amount || amount < 1} onClick={() => { setOnlinePaymentStep(1) }}>
                                            <IonText color="light">
                                                {siteText.creditAccountStartPrimary}
                                            </IonText>
                                        </IonButton>
                                        <IonButton fill="outline" color="secondary" onClick={() => { setPaymentMode(1) }}>{siteText.creditAccountStartSecondary}</IonButton>
                                    </div>
                                </form>
                            </IonCol>
                        </IonRow>
                    </IonGrid>:
                <UserTerms goBack={toggleUserTerms} ></UserTerms>}
                    <Footer></Footer>
                </IonContent>
            </IonPage> 

        );
    }
}

export default Credit;